export default "__VITE_ASSET__COKda$TQ__"